<template>
  <FirstTimeCourse :hiddenButton="true"/>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";
const FirstTimeCourse = defineAsyncComponent(
  () => import("./../CourseContent/AlertsCourse/FirstTimeCourse/first-time-course.vue")
);

export default defineComponent({
  name: "courseHowWorks",
  components: {
    FirstTimeCourse,
  },
});
</script>

<style></style>
